import { useState, useEffect } from "react";
import s from "./index.module.css";

export function ImageViewer({ images, isOpen, onClose, productName }) {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    if (images && images.length > 0) {
      setCurrentIndex(0);
    }
  }, [images]);

  if (!isOpen || !images || images.length === 0) {
    return null;
  }

  const handlePrev = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );
  };

  const handleNext = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === images.length - 1 ? 0 : prevIndex + 1
    );
  };

  const handleThumbnailClick = (index) => {
    setCurrentIndex(index);
  };

  const currentImage = images[currentIndex] || images[0] || "";

  return (
    <div className={s.imageViewerOverlay} onClick={onClose}>
      <button
        className={s.closeButton}
        onClick={onClose}
        aria-label="Close image viewer"
      >
        ✕
      </button>
      <div
        className={s.imageViewerContainer}
        onClick={(e) => e.stopPropagation()}
      >
        <div className={s.mainImageContainer}>
          <img
            src={currentImage}
            alt={`${productName || "Product"} - Image ${currentIndex + 1}`}
            className={s.mainImage}
          />

          {images.length > 1 && (
            <>
              <button
                className={`${s.navButton} ${s.prevButton}`}
                onClick={handlePrev}
                aria-label="Previous image"
              >
                ‹
              </button>
              <button
                className={`${s.navButton} ${s.nextButton}`}
                onClick={handleNext}
                aria-label="Next image"
              >
                ›
              </button>
            </>
          )}
        </div>

        <div className={s.imageCounter}>
          {currentIndex + 1} / {images.length}
        </div>

        {images.length > 1 && (
          <div className={s.thumbnailContainer}>
            {images.map((img, index) => (
              <button
                key={index}
                className={`${s.thumbnailButton} ${
                  index === currentIndex ? s.activeThumbnail : ""
                }`}
                onClick={() => handleThumbnailClick(index)}
                aria-label={`View image ${index + 1}`}
                aria-current={index === currentIndex ? "true" : "false"}
              >
                <img
                  src={img || ""}
                  alt={`Thumbnail ${index + 1}`}
                  className={s.thumbnail}
                />
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
